// extracted by mini-css-extract-plugin
module.exports =  {"cards":"ccfda6eb9f--cards--Ppj61","card":"ccfda6eb9f--card--lM2tc","img":"ccfda6eb9f--img--eFC03","content":"ccfda6eb9f--content--kXhIz","title":"ccfda6eb9f--title--sYSWh"};